import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QueueService from './QueueService';
import { faQrcode, faCog, faSignOutAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './MenuPage.css'; // Include CSS for styling



const MenuPage = ({ token, handleLogout, business_id }) => {
  const [businessInfo, setBusinessInfo] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const response = await QueueService.GetBusinessInfo(business_id);
        setBusinessInfo({
          reports_url: response.reports_url,
          whatsapp_phone_number_id: response.whatsapp_phone_number_id,
          business_metadata: response.business_metadata || {},
          brand_id: response.brand_id
        });
      } catch (error) {
        console.error('Error fetching business info:', error);
      }
    };
    fetchBusinessInfo();
  }, [token]);

  return (
    <div className="menu-page-container">
      <div className="menu-item" onClick={() => window.open('/qr-code', '_blank')}>
        <FontAwesomeIcon icon={faQrcode} size="lg" />
        <span style={{ marginLeft: '18px' }}>QR Code</span>
      </div>
      <div className="menu-item" onClick={() => window.open('/business-settings', '_blank')}>
        <FontAwesomeIcon icon={faCog} size="lg" />
        <span>Business Settings</span>
      </div>
      <div className="menu-item" onClick={() => window.open('/restrict-reservations', '_blank')}>
        <FontAwesomeIcon icon={faCog} size="lg" />
        <span>Restrict Reservations</span>
      </div>
      {businessInfo.whatsapp_phone_number_id && (
        <div className="menu-item" onClick={() => window.open(`/whatsapp?contact=${businessInfo.whatsapp_phone_number_id}`, '_blank')}>
          <FontAwesomeIcon icon={faWhatsapp} size="lg" />
          <span>WhatsApp Chats</span>
        </div>
      )}

      {businessInfo.whatsapp_phone_number_id && (
        <div className="menu-item" onClick={() => window.open('/campaigns', '_blank')}>
          <FontAwesomeIcon icon={faWhatsapp} size="lg" />
          <span>WhatsApp Campaigns</span>
        </div>
      )}

      {businessInfo.whatsapp_phone_number_id && (
        <div className="menu-item" onClick={() => window.open('/templates', '_blank')}>
          <FontAwesomeIcon icon={faWhatsapp} size="lg" />
          <span>WhatsApp Templates</span>
        </div>
      )}

      {/* Users page CTA */}
      {businessInfo.brand_id && (
        <div className="menu-item" onClick={() => window.open(`/users?brand_id=${businessInfo.brand_id}`, '_blank')}>
          <FontAwesomeIcon icon={faCog} size="lg" />
          <span>Users</span>
        </div>
      )}

      {/* Orders tab visible to all businesses */}
      <div className="menu-item" onClick={() => window.open('/orders', '_blank')}>
        <FontAwesomeIcon icon={faCog} size="lg" />
        <span>Orders</span>
      </div>
      <div className="menu-item" onClick={() => navigate('/reviews')}>
        <FontAwesomeIcon icon={faStar} size="lg" />
        <span>Customer Reviews</span>
      </div>
      <div className="menu-item" onClick={() => window.open('/business-analytics', '_blank')}>
        <FontAwesomeIcon icon={faCog} size="lg" />
        <span>Reports and Insights</span>
      </div>
      <div className="menu-item" onClick={handleLogout}>
        <FontAwesomeIcon icon={faSignOutAlt} size="lg" />
        <span>Logout</span>
      </div>
    </div>
  );
};

export default MenuPage;
